import classNames from 'classnames';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { Route } from '@/app/[lang]/Router/createRoute';
import {
  STYLE_SINGLE_PAGE_CLOSE,
  STYLE_SINGLE_PAGE_OPEN,
} from '@/components/Layout/Header/MobileHeader/consts';
import { useTranslation } from '@/hooks/useTranslations';

type SinglePagePropsType = {
  lang: string | undefined;
  name?: string | undefined;
  path?: string | undefined;
  childRoutes?: Route[] | undefined;
  onClose: VoidFunction;
  getPath?: ((lang: string) => string) | undefined;
  setSinglePage: Dispatch<SetStateAction<Route | null>>;
};

const SinglePage = ({ name, lang, childRoutes, setSinglePage, onClose }: SinglePagePropsType) => {
  const [style, setStyle] = useState<React.CSSProperties>(STYLE_SINGLE_PAGE_CLOSE);

  const { t } = useTranslation();
  const path = usePathname();

  useEffect(() => {
    setStyle(STYLE_SINGLE_PAGE_OPEN);
  }, []);

  return (
    <div className="menuBurgerGamesInfoWrp" style={style}>
      <div className="menuBurgerHomeRow">
        <div className="menuBurgerHomeRowItem">
          <i onClick={() => setSinglePage(null)} className="bc-i-arrow-left menuBurgerArrow" />
          <p className="menuBurgerHomeTitle">{t(name as string)}</p>
        </div>
      </div>
      {childRoutes?.map((route: any, index) => (
        <Link href={route.getPath(lang)} key={index} passHref onClick={onClose}>
          <div
            key={route.name}
            className={classNames('menuBurgerHomeRowItem', {
              active: route.getPath(lang) === path,
            })}
          >
            <span className="menuBurgerGamesTitle">{t(route.name)}</span>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default SinglePage;
